import { Loading } from "components/Loading";
import { PlaceHolderNotExists } from "components/PlaceholderNotExists";
import { TableModifiedCards } from "components/TableModified/TableModifiedCards";
import { TableModifiedFilters } from "components/TableModified/TableModifiedFilters";
import { TableModifiedPagination } from "components/TableModified/TableModifiedPagination";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import React, {  } from "react";
import { Container } from "./styles";
import { useLeadsTableNew } from "./useLeadsTableNew";
import { ptBR } from 'date-fns/locale';
import { registerLocale } from "react-datepicker";
registerLocale("pt", ptBR);

const tableHead = ["Data do cadastro",  "Status", "Nome Fantasia", "Categoria", "Origem", "CNPJ",  "Responsável", " "];

export const LeadsTableNew: React.FC = () => {
  const {
    loading,
    error,
    properties,
    leadRows,
    leadsCount,
    searchText,
    pageNumber,
    leadsPerPage,
    handleSearchTextRemove,
    handlePageSelected,
    handleRowsPerPageChange,
    tableFilters,
    handleFilterChange,
    handleFilterRemove,
  } = useLeadsTableNew();

  return (
    <Container>
      <TableModifiedFilters
        filters={tableFilters}
        searchTextFilter={searchText}
        onFilterChange={handleFilterChange}
        onFilterRemove={handleFilterRemove}
        onSearchTextRemove={handleSearchTextRemove}
      />
      {
        loading
        ? <Loading/>
        : error
          ? <PlaceHolderNotExists title="Erro ao se comunicar com o servidor"/>
          : <>
              <TableModifiedCards
                properties={properties}
              />
              <TableModifiedTable
                headerColumns={tableHead}
                rows={leadRows}
              />
            </>
      }
      {
        leadsCount > 0
        ? <TableModifiedPagination
            totalItemsCount={leadsCount}
            pageNumber={pageNumber}
            rowsPerPage={leadsPerPage}
            onPageSelected={handlePageSelected}
            onRowsPerPageChange={handleRowsPerPageChange}
          />
        : null
      }
    </Container>
  );
}
